// mixin.js
import { MUTATE_SHOW_VERIFY_EMAIL } from '@/store/modules/interface';
import Vue from 'vue';
import Component from 'vue-class-component';

// You can declare a mixin as the same style as components.
@Component
export default class ShowVerifyEmailMixin extends Vue {
    public showVerifyEmailDialog() {
        this.$store.commit(MUTATE_SHOW_VERIFY_EMAIL, true);
    }
}
